// Utility functions for managing dropdown configurations via API

import { settingsApi } from '../api/api';

const DEFAULT_OPTIONS = {
  status: ['Folyamatban', 'Aktív', 'Nem aktív'],
  type: ['PV', 'BESS', 'SZÉL'],
  integrator: ['SUNdroid', 'ControlPass', 'ProAktív', 'Saját', 'ÁramútBau'],
};

// Cache for dropdown options to reduce API calls
let optionsCache = {};
let cacheTimestamp = null;
const CACHE_DURATION = 60000; // 1 minute

export async function getDropdownOptions(type) {
  // Check cache validity
  if (cacheTimestamp && Date.now() - cacheTimestamp < CACHE_DURATION && optionsCache[type]) {
    return optionsCache[type];
  }

  try {
    const response = await settingsApi.getDropdownOptions(type);
    const options = response.data || DEFAULT_OPTIONS[type] || [];

    // Update cache
    optionsCache[type] = options;
    cacheTimestamp = Date.now();

    return options;
  } catch (error) {
    console.error(`Error fetching dropdown options for ${type}:`, error);
    // Return cached value if available, otherwise default
    return optionsCache[type] || DEFAULT_OPTIONS[type] || [];
  }
}

export async function setDropdownOptions(type, options) {
  try {
    await settingsApi.updateDropdownOptions(type, options);

    // Update cache
    optionsCache[type] = options;
    cacheTimestamp = Date.now();

    return true;
  } catch (error) {
    console.error(`Error updating dropdown options for ${type}:`, error);
    return false;
  }
}

export function getDefaultOptions(type) {
  return [...DEFAULT_OPTIONS[type]] || [];
}

// Helper to invalidate cache (useful for testing or manual refresh)
export function clearDropdownCache() {
  optionsCache = {};
  cacheTimestamp = null;
}
